const { detect } = require('detect-browser');

export default {
    // name: 'detect_ie',
    data () {
        return {}
    },
    computed: {
        userAgent () {
            const browser = detect();
            if (process.env.VUE_APP_BUILD_ENV !== 'production') {
                if (browser) {
                    console.log(`browser.name => ${browser.name}`);
                    console.log(`browser.version => ${browser.version}`);
                    console.log(`browser.os => ${browser.os}`);
                }
            }
            return browser
        },
        isIE () {
            // 실제 IE 계열만 true (ios/samsung/crios 등 그 외 브라우저는 IE 가 아님). userAgent 가 null 이면 false
            return !!this.userAgent && ['ie', 'trident', 'msie', 'microsoft internet explorer'].includes(this.userAgent.name.toLowerCase())
        }
    }
}